import * as React from "react";
import { Segment, Header, Table, TableHeader, TableHeaderCell, TableRow, TableBody, TableCell } from "@/components/bp/bp-ui";
import { TranslationContext } from "../Contexts/TranslationContext";
import { CaseRunCalculateModel, ClientResources, ParameterReadModel, ParameterTypes } from "@app/api2/api";
import { IParameterRenderer } from "./ParameterRendererAbstracts";
import { BPButton } from "@/components/bp/bpbutton";

interface IReviewCalculateProps {
    model: CaseRunCalculateModel;
    onComplete: (values: any) => void;
    // router: any;
    parameterRenderer: IParameterRenderer;
}

class ReviewCalculateState {

}

export class ReviewCalculate extends React.Component<IReviewCalculateProps, ReviewCalculateState> {

    constructor(props, context) {
        super(props, context);

        this.state = {

        };

    }

    isRowVisible = (p: ParameterReadModel) => {
        if (!p.userVisible) {
            return false;
        }
        if (!p.showIfChecked) {
            return true;
        }

        var fields = p.showIfChecked.split(',');

        var falseFields = fields.filter(f => f.startsWith("!")).map(m => m.slice(1));
        var trueFields = fields.filter(f => !f.startsWith("!"));

        var values = this.props.model.parameters.reduce((dict, curr) => {
            dict[curr.parameter] = curr.value;
            return dict;
        }, {});

        return falseFields.reduce((show, field) => show && !(values[field] === "1"), true) && trueFields.reduce((show, field) => show && (values[field] === "1"), true);
    };

    render() {
        return (<TranslationContext.Consumer>{t => <div>
            <Header attached="top">{t.common.parameters}</Header>
            <Segment attached>
                {/* <SimpleParameters labId={this.props.model.labId} parameters={this.props.model.parameters} caseRunCreateModel={this.props.model} parameterRenderer={this.props.parameterRenderer} disabled={true} onParametersChanged={() => { }}></SimpleParameters> */}

                <Table definition striped>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell>{t.common.parameter}</TableHeaderCell>
                            <TableHeaderCell>{t.common.value}</TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {this.props.model.parameters.map((p) => (
                            this.isRowVisible(p) && this.renderParameters(p, t)
                        ))}
                    </TableBody>
                </Table>
            </Segment>
            <Segment basic clearing>
                <BPButton floated="right" type="submit" onClick={this.props.onComplete} positive primary>{t.caseRun.queueRun}</BPButton>
            </Segment>
        </div>}</TranslationContext.Consumer>);
    }

    private renderParameters(p: ParameterReadModel, t: ClientResources): JSX.Element {
        const hasCustomRenderer = this.props.parameterRenderer && this.props.parameterRenderer.canRenderParameter(p.parameter);

        return <TableRow key={p.parameter}>
            <TableCell>{t.parameter.names[p.parameter]}</TableCell>
            <TableCell>
                {hasCustomRenderer &&
                    <span>
                        {this.props.parameterRenderer.renderParameterView({ model: { ...this.props.model, efmCaseId: this.props.model.efmCaseId }, p })}
                    </span>}
                {(!hasCustomRenderer && (p.parameterType === ParameterTypes.Number || p.parameterType === ParameterTypes.Integer || p.parameterType === ParameterTypes.String)) &&
                    p.value}
                {(!hasCustomRenderer && (p.parameterType === ParameterTypes.Boolean) && (p.value === "1" ? t.common.yes : t.common.no))}
            </TableCell>
        </TableRow>;
    }
}